import { render, staticRenderFns } from "./richEditor.vue?vue&type=template&id=46182248&"
import script from "./richEditor.vue?vue&type=script&lang=js&"
export * from "./richEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports